import { SelectValue } from 'src/components/Selects/EntityVersionSearch/types'

import { AddressEntryType } from '../../../../types/graphql'
import { useGetEntityLayersQuery } from '../../../fetch/entityLayers'
import { SelectFieldProps } from '../../../utils/forms'
import EntityVersionSearchInternals from '../../Selects/EntityVersionSearch/EntityVersionSearchInternals'

type Props<TKey extends string> = {
  caption?: React.ReactNode
  label?: React.ReactNode
  placeholder?: string
  entityLayerIds: number[]
  disabledEntityIds?: Set<number>
  addressEntryType: AddressEntryType
} & SelectFieldProps<SelectValue, TKey>
const EntityVersionSearchField = <TKey extends string>({
  label,
  placeholder,
  entityLayerIds,
  disabledEntityIds,
  field,
  isMultiSelect,
  addressEntryType,
}: Props<TKey>) => {
  const { entityLayers, isLoading } = useGetEntityLayersQuery(entityLayerIds)

  const errorMessage = field.state.meta.errors.join(', ')
  const isInvalid = !!errorMessage

  const commonProps = {
    addressEntryType,
    disabledEntityIds,
    entityLayers,
    isLoadingEntityLayers: isLoading,
    label,
    placeholder,
    errorMessage,
    isInvalid,
    onBlur: field.handleBlur,
  }

  if (isMultiSelect) {
    return (
      <EntityVersionSearchInternals
        isMultiSelect={true}
        applyConditionsFieldKey={field.name}
        onValueChange={field.setValue}
        value={field.state.value}
        {...commonProps}
      />
    )
  }
  return (
    <EntityVersionSearchInternals
      isMultiSelect={false}
      applyConditionsFieldKey={field.name}
      onValueChange={field.setValue}
      value={field.state.value}
      {...commonProps}
    />
  )
}

export default EntityVersionSearchField
